import {
  SURVEY_VIEW_GET_FORM,
  SURVEY_UPT_PAGE_VISIBLE,
  SURVEY_VIEW_GET_FORM_SUCCESS,
  SURVEY_VIEW_GET_FORM_ERROR,
  GET_ANS,
  UPT_ANS,
  GET_ANS_SUCCESS,
  GET_ANS_ERROR,
  CLR_QUES_1,
  CLR_QUES_2,
  SURVEY_VIEW_SET_VALIDATION,
  SURVEY_VIEW_UNSET_VALIDATION,
  SURVEY_VIEW_SET_PAGE_TOUCH_VALIDATION,
  SET_DUP_CID,
  SURVEY_VIEW_LIVE_SCORE,
} from '../actions';

const INIT_STATE = {
  requestError: { error: false, errorMessage: "" },
  error: false,
  survey: null,
  ans: null,
  loading: false,
  prefill: false,
  done: false,
  isScore: false,
  isScoreFinish: false,
  cidDuplicatechk: false,
  questionValidation: [],
  pageTouchValidation: [],
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case SURVEY_VIEW_GET_FORM:
      // console.log(1)
      return { ...state, loading: false };

    case SURVEY_VIEW_GET_FORM_SUCCESS:
      // console.log(action.payload.svy,  action.payload.ansdata);
      // return {
      //   ...state,
      //   loading: true,
      //   survey: action.payload,
      // };
      if (action.payload.svy !== undefined && action.payload.ansdata !== undefined) {
        let premode = false;
        const url = new URL(window.location.href);
        const pref = url.searchParams.get('_p');
        if (pref != null && pref == "2") {
          premode = true;
        }
        return {
          ...state,
          loading: true,
          done: true,
          survey: action.payload.svy,
          prefill: premode,
          ans: action.payload.ansdata
        };
      }

    case SURVEY_VIEW_GET_FORM_ERROR:
      return {
        ...state, loading: true, error: action.payload.error,
        requestError: { error: action.payload.error, errorMessage: action.payload.errorMessage }
      };
    
    case SURVEY_VIEW_LIVE_SCORE:
      if (action.payload.isScore == true) {
        return {
          ...state, isScore: action.payload.isScore
        };
      } else if (action.payload.isScoreFinish == true) {
        return {
          ...state, isScoreFinish: action.payload.isScoreFinish
        };
      }

    case SURVEY_UPT_PAGE_VISIBLE:
      return { ...state, loading: false };

    case GET_ANS:
      return { ...state, loading: false };

    case GET_ANS_SUCCESS:
      if (action.payload.ans != undefined) {
        return {
          ...state,
          loading: true,
          done: true,
          ans: action.payload.ans,
          survey: action.payload.sur
        };
      }
      return {
        ...state,
        loading: true,
        done: true,
        ans: action.payload,
      };

    case GET_ANS_ERROR:
      // console.log(action.payload)
      return { ...state, loading: true, error: action.payload };

    case SET_DUP_CID:
      // console.log(action.payload)
      return { ...state, loading: true, cidDuplicatechk: action.payload };

    case UPT_ANS:
      return { ...state, loading: false };

    case CLR_QUES_1:
      return { ...state, loading: false };

    case CLR_QUES_2:
      return { ...state, loading: false };

    case SURVEY_VIEW_SET_VALIDATION:
      // let checkSetObj = state.questionValidation.filter(obj => obj.questionID == action.payload.questionID);
      return { ...state, questionValidation: [...state.questionValidation.filter(obj => obj.questionID != action.payload.questionID), action.payload] };

    case SURVEY_VIEW_UNSET_VALIDATION:
      return { ...state, questionValidation: state.questionValidation.filter(obj => obj.questionID != action.payload.questionID) };

    case SURVEY_VIEW_SET_PAGE_TOUCH_VALIDATION:
      let checkPageTouch = state.pageTouchValidation.indexOf(action.payload.pageArrayIndex);
      return { ...state, pageTouchValidation: (checkPageTouch == -1) ? ([...state.pageTouchValidation, action.payload.pageArrayIndex]) : ([...state.pageTouchValidation]) };

    default:
      return { ...state };
  }
};
